// @ts-nocheck

function variantIdFromGid(shopifyVariantId) {
  const value = String(shopifyVariantId || "");
  const parts = value.split("/");
  return parts[parts.length - 1] || "";
}

function buildVariantQuantityMap(payload) {
  const responses = Array.isArray(payload) ? payload : [payload];
  const map = {};

  responses.forEach(function (entry) {
    const items = entry && entry.data && entry.data.items;
    if (!Array.isArray(items)) return;

    items.forEach(function (item) {
      const id = variantIdFromGid(item && item.shopify_variant_id);
      const quantity = Number(item && item.quantity) || 0;
      if (!id) return;
      map[id] = (map[id] || 0) + quantity;
    });
  });

  return map;
}

async function readCart() {
  const response = await fetch("/cart.js", {
    headers: { Accept: "application/json" },
  });
  return response.json().catch(function () {
    return null;
  });
}

function existingQuantities(cart) {
  const existing = {};
  ((cart && cart.items) || []).forEach(function (item) {
    const id = String(item.variant_id || item.id);
    existing[id] = (existing[id] || 0) + (Number(item.quantity) || 0);
  });
  return existing;
}

function splitCartChanges(variantQuantityMap, existing) {
  const toAdd = [];
  const updates = {};

  Object.keys(variantQuantityMap || {}).forEach(function (id) {
    const backendQty = Number(variantQuantityMap[id]) || 0;
    if (!backendQty) return;

    const cartQty = existing[id] || 0;
    if (!cartQty) {
      toAdd.push({ id: Number(id), quantity: backendQty });
      return;
    }
    if (backendQty > cartQty) updates[id] = backendQty;
  });

  return { toAdd: toAdd, updates: updates };
}

async function postCart(path, body) {
  const response = await fetch(path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(body),
  });
  return response.ok;
}

function notifyCart(cart) {
  document.dispatchEvent(
    new CustomEvent("cart:update", {
      bubbles: true,
      detail: {
        data: {
          itemCount: cart && cart.item_count,
          source: "pw-cart-migration",
        },
      },
    })
  );
}

var PW_CART_SYNC_KEY = "pw-cart-sync-at";
var PW_CART_SYNC_GAP_MS = 5 * 60 * 1000;

function readCartSyncAt() {
  try {
    var raw = localStorage.getItem(PW_CART_SYNC_KEY);
    var time = raw ? Date.parse(raw) : NaN;
    return isNaN(time) ? 0 : time;
  } catch (e) {
    return 0;
  }
}

function writeCartSyncAt() {
  try {
    localStorage.setItem(PW_CART_SYNC_KEY, new Date().toISOString());
  } catch (e) {}
}

function cartSyncTooSoon() {
  var last = readCartSyncAt();
  if (!last) return false;
  return Date.now() - last < PW_CART_SYNC_GAP_MS;
}

async function addVariantsToGokwikCart(variantQuantityMap) {
  const currentCart = await readCart();
  const { toAdd, updates } = splitCartChanges(variantQuantityMap, existingQuantities(currentCart));
  const hasUpdates = Object.keys(updates).length > 0;
  if (!toAdd.length && !hasUpdates) return currentCart;

  let ok = true;
  if (toAdd.length) ok = (await postCart("/cart/add.js", { items: toAdd })) && ok;
  if (hasUpdates) ok = (await postCart("/cart/update.js", { updates: updates })) && ok;
  if (!ok) return null;

  const cart = await readCart();
  notifyCart(cart);
  return cart;
}

async function migratePwCart() {
  const customerId = window.PW_CUSTOMER_ID ? String(window.PW_CUSTOMER_ID) : "";
  if (!customerId) return;

  let stored = null;
  try {
    stored = JSON.parse(localStorage.getItem("STORE_TOKEN_CONTEXT") || "null");
  } catch (e) {}

  const token = localStorage.getItem("pw-sync-token") || (stored && stored.token) || null;
  if (!token) return;
  if (cartSyncTooSoon()) return;

  const base = window.PW_API_BASE || "/apps/pw_module/api";
  try {
    const response = await fetch(base + "/utilities/pw-cart", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "customer-id": customerId,
      },
    });
    if (!response.ok) return;

    writeCartSyncAt();

    const data = await response.json().catch(function () {
      return null;
    });
    const variantQuantityMap = buildVariantQuantityMap(data);
    await addVariantsToGokwikCart(variantQuantityMap);
  } catch (e) {}
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    if (window.hasCustomer === true && window.PW_CUSTOMER_ID) migratePwCart();
  });
} else if (window.hasCustomer === true && window.PW_CUSTOMER_ID) {
  migratePwCart();
}

window.migratePwCart = migratePwCart;
